// composables/useDeviceDetection.js
import { ref, onMounted, onUnmounted } from 'vue'

export function useDeviceDetection(breakpoint = 768, debounceDelay = 300) {
  const isMobile = ref(window.innerWidth < breakpoint)
  
  function checkDeviceChange() {
    const currentIsMobile = window.innerWidth < breakpoint
    
    if (currentIsMobile !== isMobile.value) {
      console.log(`设备类型变化: ${isMobile.value ? '手机' : '桌面'} -> ${currentIsMobile ? '手机' : '桌面'}`)
      
      // 可以选择直接刷新或者返回变化状态让组件决定
      window.location.reload()
    }
    
    isMobile.value = currentIsMobile
  }
  
  function debounce(func, delay) {
    let timeoutId
    return function (...args) {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => func.apply(this, args), delay)
    }
  }
  
  const debouncedCheck = debounce(checkDeviceChange, debounceDelay)
  
  onMounted(() => {
    window.addEventListener('resize', debouncedCheck)
  })
  
  onUnmounted(() => {
    window.removeEventListener('resize', debouncedCheck)
  })
  
  return {
    isMobile
  }
}